import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSuperbarIcon = (
  {
    title,
    titleId,
    desc,
    descId,
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 15 10"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#fff"
      d="M6.04 0h7.916c.575 0 1.042.466 1.042 1.042v2.916c0 .575-.466 1.041-1.042 1.041H11.04c-.575 0-1.041.467-1.041 1.042v2.916c0 .575-.467 1.041-1.042 1.041H1.042A1.04 1.04 0 0 1 0 8.958V6.041c0-.575.466-1.042 1.042-1.042h2.916c.575 0 1.041-.466 1.041-1.041V1.042C5 .466 5.466 0 6.041 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSuperbarIcon);
const Memo = memo(ForwardRef);
export default Memo;
